/** Sorts in place by search-relevance rank (see Fuse result order); ids without a rank go last. */
export function sortByRelevance<T extends { id: number }>(items: T[], orderMap: Map<number, number>): void {
  items.sort((a, b) => (orderMap.get(a.id) ?? Infinity) - (orderMap.get(b.id) ?? Infinity))
}
